/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-03-18 14:12:50
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-10-12 11:47:15
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\ToolMaintenance\api\toolapi.js
 */
//宣教内容

//引入接口文档
import req from '@/utils/req.js'


//获取宣教内容表格数据
export function api_get_mission_list(params) {
    return req.post("/admin/mission/page", params);
}
//获取宣教内容表格数据
// export function api_get_mission_list(params) {
//     return req.post("/admin/mission/page/diseaseSymptomNameList", params);
// }

//删除 宣教表格数据
export function api_del_mission(id) {
    return req.delete(`/admin/mission/${id}`);
}
//获取患者列表
export function api_get_instrument_list(params) {
    return req.get("/admin/patient/instrument", params);
}
//请求疾病类型
export function diseaseType(params) {
    return req.get("/admin/disease-type", params);
}
//批量推送宣教
export function pushbatch(params) {
    return req.post("/admin/mission/push/mission/batch", params);
}

//宣教列表分页查询
export function api_get_mission(params) {
    return req.post("/admin/mission/page", params);
}

export function api_get_listPullDown(params) {
    return req.post("admin/hospital/listPullDown", params);
}

//请求疾病类型
export function missionQuote(params) {
    return req.get(`/admin/mission/quote/${params}`);
}

//用户问卷统计
export function examPaperStatistics(params) {
    return req.post("admin/qs-answer-sheet/examPaperStatistics", params);
}

//用户问卷统计导出excel
export function exportExamPaperStatistics(params) {
    // return req.postUpload(`admin/qs-answer-sheet/exportExamPaperStatistics`, params, { responseType: 'arraybuffer' })
    return req.postUpload(`admin/qs-answer-sheet/export`, params, { responseType: 'arraybuffer' })
    // return req.post("admin/qs-answer-sheet/exportExamPaperStatistics", params);
}


//关键字分页模糊查询团队服务
export function getTeamServicePage(params) {
    return req.post("admin/team-service/getTeamServicePage", params);
}

//查询已配置的服务
export function getTeamServiceDetail(params) {
    return req.get(`admin/qs-exam-paper-recommend-service/detailByExamPaperId/${params}`);
}

export function delTeamServiceDetail(params) {
    return req.delete(`admin/qs-exam-paper-recommend-service/deleteByExamPaperId/${params}`);
}

//服务配置保存
export function recommendService(params) {
    return req.post("admin/qs-exam-paper-recommend-service/saveByExamPaperId", params);
}

//宣教基本信息
export function getDiseaseSymptomSelect(params) {
    return req.post("admin/disease-common-symptom/getDiseaseSymptomSelect", params);
}



